import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getApi } from "../../../store/apis";
import EmptyData from "../../../components/base/EmptyData";
import SkeletonTable from "../../../components/base/SkeletonTable";
import { ArrowDropDown, AddCircle } from "@mui/icons-material";
import SearchDataTable from "../../../components/base/searchDataTable";
import { Button, Pagination, Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import day from "dayjs";
import { Menu, MenuItem } from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
import DialogAdd from "../../../components/base/dialogAdd";
import IndividualUserCreate from "../IndividualUser/individualUserCreate";

const CompanyClient = ({ id }) => {
  const dispatch = useDispatch();
  const theme = useSelector((state) => state.theme.myTheme);
  const [find, setFind] = useState("");
  const [loading, setLoading] = useState(true);
  const [dataSet, setData] = useState([]);
  const [emptyTxt, setEmptyTxt] = useState("");
  const [openDialogAdd, setOpenDialogAdd] = useState(false);
  const [openFormUser, setOpenFormUser] = useState(false);

  const [state, setState] = useState({
    page: 1,
    limit: 10,
    last_page: null,
    total: null,
    gender: "",
    profesi: "",
    tipeSort: null,
    asc: true,
  });

  const fetchData = () => {
    setLoading(true);
    let page = `&page[size]=${state.limit}&page[number]=${state.page}`;
    let data = {
      path: `admin/company/pelanggan?id=${id}${page}`,
    };

    dispatch(getApi(data))
      .then((data) => {
        setLoading(false);
        setData(data.data);
        setState({ ...state, total: data.total, last_page: data.last_page });
      })
      .catch((err) => {
        if (err.status == 400) {
          if (find != "") {
            setEmptyTxt(`${find} tidak cocok untuk data apapun!`);
          } else {
            setEmptyTxt(`No Data Available`);
          }
        } else {
          setEmptyTxt(`${err.status}: ${err.data.message}`);
        }
        setLoading(false);
        setData([]);
      });
  };
  const handlePage = (event, value) => {
    setState({ ...state, page: value });
  };
  const listLimit = [10, 50, 100];

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.limit, find, state.page]);

  return (
    <div>
      <Paper className="pa-3 rounded-lg mt-3">
        <div>
          <h3>List Pengguna</h3>
        </div>
        <div className="d-flex flex-wrap align-center justify-space-between mt-3 mb-4">
          <div className="d-flex align-center">
            <p className="small_txt font-weight-500 mr-2" style={{ color: theme.primary }}>
              Tampilkan
            </p>
            <Menu
              menuClassName="my_menu"
              menuButton={
                <div className="px-3 py-2 rounded-lg d-flex align-center mr-5 cursor_pointer pb-2" style={{ border: `2px solid ${theme.lighten}` }}>
                  <p className="small_txt font-weight-bold mr-3">{state.limit} Data</p>
                  <ArrowDropDown />
                </div>
              }
              transition>
              {listLimit.map((lm, i) => (
                <MenuItem key={`limit-${i}`} onClick={() => setState({ ...state, limit: lm })}>
                  <p className="font-weight-bold txt_table">{lm} Data</p>
                </MenuItem>
              ))}
            </Menu>
            <div className="mr-5">
              <SearchDataTable value={find} setValue={setFind} />
            </div>
          </div>
          <div className="d-flex flexy justify-end">
            <Button className="capitalize rounded-lg" onClick={() => setOpenDialogAdd(true)} color={"primary"} disableElevation variant="contained">
              <AddCircle color="white" className="mr-2" />
              <p className="font-weight-bold">Tambah</p>
            </Button>
          </div>
        </div>
        {!loading ? (
          !dataSet.length ? (
            <EmptyData />
          ) : (
            <TableContainer component="div">
              <Table aria-label="simple table" style={{ borderBottom: "none" }}>
                <TableHead>
                  <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                    <TableCell
                      style={{
                        minWidth: "50px",
                        background: theme.tertiary,
                        borderRadius: "10px 0 0 10px",
                      }}
                      className="py-2">
                      <p className="font-weight-bold" style={{ color: theme.primary }}>
                        User ID
                      </p>
                    </TableCell>
                    <TableCell style={{ minWidth: "100px", background: theme.tertiary }} className="py-1">
                      <p className="font-weight-bold" style={{ color: theme.primary }}>
                        Nama User
                      </p>
                    </TableCell>
                    <TableCell style={{ minWidth: "150px", background: theme.tertiary }} className="py-1">
                      <p className="font-weight-bold" style={{ color: theme.primary }}>
                        Email
                      </p>
                    </TableCell>
                    <TableCell style={{ minWidth: "150px", background: theme.tertiary }} className="py-1" align="center">
                      <p className="font-weight-bold" style={{ color: theme.primary }}>
                        Nomor Hp
                      </p>
                    </TableCell>
                    <TableCell
                      style={{
                        minWidth: "120px",
                        background: theme.tertiary,
                      }}
                      className="py-1"
                      align="center">
                      <p className="font-weight-bold" style={{ color: theme.primary }}>
                        Tgl Lahir
                      </p>
                    </TableCell>
                    <TableCell style={{ minWidth: "100px", background: theme.tertiary, borderRadius: "0 10px 10px 0" }} className="py-1">
                      <p className="font-weight-bold" style={{ color: theme.primary }}>
                        Tgl. Reg.
                      </p>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataSet.map((item, i) => (
                    <TableRow key={i} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                      <TableCell>{item.id}</TableCell>
                      <TableCell>{item.data_pelanggan?.nama ?? "-"}</TableCell>
                      <TableCell>{item.data_pelanggan?.email ?? "-"}</TableCell>
                      <TableCell className="text-center">{item.data_pelanggan?.no_telp ?? "-"}</TableCell>
                      <TableCell className="text-center">{item.data_pelanggan?.tgl_lahir ? day(item.data_pelanggan?.tgl_lahir).format("DD/MM/YY") : "-"}</TableCell>
                      <TableCell>
                        <p className="small_txt">{day(item.created_at).format("DD/MM/YY | HH:mm")}</p>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )
        ) : (
          <SkeletonTable txt={emptyTxt} />
        )}
        {dataSet.length ? (
          <div className="d-flex align-center justify-space-between" style={{ width: "100%" }}>
            <p className="txt_table">
              Menampilkan {state.page} - {state.limit} dari {state.total}{" "}
            </p>
            <div>
              <Pagination sx={{ padding: "0" }} count={state.last_page} page={state.page} shape="rounded" onChange={handlePage} style={{ background: "#fff" }} color="primary" />
            </div>
          </div>
        ) : (
          <></>
        )}
      </Paper>
      <DialogAdd open={openDialogAdd} onClose={() => setOpenDialogAdd(false)} onClickManual={() => setOpenFormUser(true)} />
      <div className="pa-2">
        <IndividualUserCreate
          d_indie={openFormUser}
          close={() => setOpenFormUser(false)}
          refetch={fetchData}
          forCompany={{
            id,
            url: "admin/company/pelanggan/store",
            onCloseDialogAdd: () => setOpenDialogAdd(false),
          }}
        />
      </div>
    </div>
  );
};

export default CompanyClient;
